import React from 'react';
import { Sparkles } from 'lucide-react';

const WhiteLabelBenefits = () => {
  const features = [
    'Custom branding',
    'Branded Traaining libraries',
    'AI-powered role-play tailored to your methodology',
    'White-labeled dashboards and analytics',
    'Multi-client management from one console'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            White-Labeled by <span className="text-cyan-400">Design</span>
          </h2>
          <p className="text-2xl text-gray-300 font-semibold">
            Traain becomes your platform.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="mb-12">
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-900/80 to-purple-900/20 border border-purple-500/30"
                >
                  <Sparkles className="w-5 h-5 text-purple-400 flex-shrink-0" />
                  <p className="text-lg text-gray-300">{feature}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-purple-900/20 to-blue-900/30 border border-purple-500/30">
            <p className="text-xl text-white font-semibold">
              Your programs become repeatable, sellable, and enterprise-ready.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhiteLabelBenefits;
